// test893
(893 && 0);
